<template>
  <div>
    <RowCard :multiLinePadding="true" theme="none" :key="i"  style="position: relative" >
      <div :style="{ width: headers[0].width }" class="d-flex ">
        <v-btn class="btn-custom"  small icon @click="onPreview">
          <Iconify icon="carbon:view-filled" size="15px"></Iconify>
        </v-btn>
        <v-btn  class="btn-custom" small icon @click="onEdit">
          <Iconify icon="material-symbols:edit" class="theme-color-seven" size="15px"></Iconify>
        </v-btn>
        <v-btn  class="btn-custom" small icon @click="onDelete(item.id)">
          <Iconify style="color: #b1b1b1" icon="basil:trash-alt-solid" size="15px"></Iconify>
        </v-btn>
      </div>
      <div :style="{ width: headers[1].width, textAlign: headers[1].align }">
        {{ item.no }}
      </div>
      <div :style="{ width: headers[2].width, textAlign: headers[2].align }">
       <div>
          {{ item.projectCode }}
       </div> 
       <div class="theme-color-seven">
          สร้างโครงการ
       </div> 
      </div>
      <div :style="{ width: headers[3].width, textAlign: headers[3].align }" :class="{ 'theme-color-seven': redText }" class="one-line"
        style="height: 20px">
        <tooltip-text
          :text="
            item.projectName
          "
        />
      </div>
      <div :style="{ width: headers[4].width, textAlign: headers[4].align }" class="one-line" style="height: 20px">
        {{ item.fiscalYear }}
      </div>
      <!--   RSP   -->
      <div class="one-line" style="height: 20px" :style="{ width: headers[5].width, textAlign: headers[5].align  }">
        {{ item.plan }}
      </div>
      <div class="one-line" style="height: 20px" :style="{ width: headers[6].width, textAlign: headers[6].align  }">
                {{ item.researcher }}

      </div>
      <div class="one-line" style="height: 20px" :style="{ width: headers[7].width , textAlign: headers[7].align }">
                        {{ item.incashPercent }}
      </div>
      <div :style="{
          width: headers[8].width,
         textAlign: headers[8].align
        }">
        8
      </div>
   <div :style="{ width: headers[9].width,
         textAlign: headers[9].align }">
         9
   </div>
      <div :style="{ width: headers[10].width,
         textAlign: headers[10].align }">
         10
   </div>
  <!--   USP   -->
  <!-- <div
        class="one-line"
        style="height: 20px"
        :style="{ width: headers[5].width }"
      >
        <tooltip-text :text="item?.created_by" />
      </div>
      <div
        class="one-line"
        style="height: 20px"
        :style="{
          width: headers[6].width,
        }"
      >
        {{ item.status }}
      </div> -->
  </RowCard>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateFormat, formatNumber } from "@/plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "TechEvalItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    }
  },
  data() {
    return {
      toDateFormat,
      formatNumber,
      theme: 2,
      redText: false,
      rand: "cl-" + Math.random().toString().slice(2),
      isExpanded: false,
    };
  },
  // computed: {
  //   ...mapState({
  //     isRSP: (state) => state.Auth.User.user_type === "RSP",
  //     isUSP: (state) => state.Auth.User.user_type === "USP",
  //     isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
  //   }),
  // },
  methods: {
    onEdit() {
      this.$router.push({ name: "TechnologyEvaluationEdit",
      //  query: { id: this.item.id } 
      });
    },
    onUpdate(status) {
      // this.$emit("onUpdateStatus", status);
    },

    onDelete(id) {
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("TechnologyEvaluation/delete",id);
          if (res) {
            // this.$store.commit("General/setModal", {
            //   title: "เสร็จสิ้น!",
            //   theme: "success",
            //   text: res,
            //   showCancel: false,
            // });
            window.location.reload();
          }
        },
      });
    },
    onPreview() {
      this.$router.push({
        name: "TechnologyEvaluation",
        query: { id: this.item.id, preview: true },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
.btn-custom{
  width: 15px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
</style>
